import { FormFieldProps } from '@Constants/interface/FormInterface';

/* eslint-disable import/prefer-default-export */
export const mapLayersFormFields: FormFieldProps[] = [
  {
    label: 'Name',
    inputType: 'text',
    type: 'input',
    placeholder: 'Enter Map Layer Name',
    id: 'name_en',
    name: 'name_en',
    required: true,
  },
  {
    label: 'Layer Type',
    inputType: 'text',
    type: 'select',
    placeholder: 'Layer Type',
    id: 'type_of_layer',
    name: 'type_of_layer',
    choose: 'value',
    isVisible: true,
    required: true,
  },
  {
    label: 'Geometry Type',
    inputType: 'text',
    type: 'select',
    placeholder: 'Geometry Type',
    id: 'geometry_type',
    name: 'geometry_type',
    choose: 'value',
    isVisible: true,
    required: true,
  },
  {
    label: 'Choose Fill Color',
    inputType: 'color',
    type: 'input',
    // placeholder: 'Please upload file (.shp or .geojson file format)',
    id: 'fill_color',
    name: 'color',
    fileAccept: '.geojson,.shp',
    className: 'naxatw-w-[100px] naxatw-py-1',
    isVisible: true,
    required: true,
  },
  {
    label: 'Source',
    inputType: 'text',
    type: 'input',
    placeholder: 'source',
    id: 'source',
    name: 'source',
    isVisible: true,
    required: false,
  },
  {
    label: 'Upload Map Layer',
    inputType: 'file',
    type: 'file-upload',
    placeholder:
      'Please upload file (.shp,.geojson,.kml,.osm,.wsm file format)',
    id: 'file_upload',
    name: 'file_upload',
    fileAccept: '.geojson, .shp, .zip',
    multiple: false,
    required: true,
  },
];

export const mapLayersDefaultValues = {
  name_en: '',
  type_of_layer: '',
  geometry_type: '',
  // file_upload: [{ file: null, name: '' }],
  file_upload: [],
  fill_color: '',
  style_id: null,
};

export const dropDownOptions: any = {
  type_of_layer: [
    {
      id: 1,
      label: 'Shapefile',
      value: 'Shapefile',
    },
    {
      id: 2,
      label: 'Geojson',
      value: 'Geojson',
    },
    {
      id: 3,
      label: 'CSV',
      value: 'CSV',
    },
    {
      id: 4,
      label: 'KML',
      value: 'KML',
    },
    {
      id: 5,
      label: 'OSM',
      value: 'OSM',
    },
    {
      id: 6,
      label: 'WMS',
      value: 'WMS',
    },
  ],
  geometry_type: [
    {
      id: 1,
      label: 'Polygon',
      value: 'Polygon',
    },
    {
      id: 2,
      label: 'LineString',
      value: 'LineString',
    },
    {
      id: 3,
      label: 'Point',
      value: 'Point',
    },
  ],
};
